"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Board_1 = require("./Board");
var pieces_1 = require("./pieces");
var constantes_1 = require("./constantes");
var virtualBoard = new Board_1.default();
virtualBoard.history.maxLength = 0;
var AI = /** @class */ (function () {
    function AI(board, color, delay) {
        var _this = this;
        if (delay === void 0) { delay = 0; }
        this.onHistoryChange = function (state) {
            if (!_this.board.mustBePromoted && state.whoseTurn === _this.color) {
                // si c'est à l'IA de jouer
                _this.move(state);
            }
            else if (_this.board.mustBePromoted &&
                _this.board.mustBePromoted.color === _this.color) {
                // si l'IA doit promouvoir un pion
                _this.promote(state);
            }
        };
        this.board = board;
        this.color = color;
        this.delay = delay;
        this.board.history.subscribe(this.onHistoryChange);
        var state = this.board.getState();
        if (state)
            this.onHistoryChange(state);
    }
    AI.prototype.move = function (state) {
        var _this = this;
        console.log('AI find best move...');
        var numPieces = 0;
        var numEnnemies = 0;
        state.pieces.forEach(function (piece) {
            if (piece.color === _this.color) {
                numPieces++;
            }
            else {
                numEnnemies++;
            }
        });
        var moves = this.board.getLegalMovesFlat();
        var bestMove = null;
        var bestScore = -Infinity;
        moves.forEach(function (move) {
            virtualBoard.setState(state);
            var piece = virtualBoard.getPiece(move.x, move.y);
            virtualBoard.move(move.x, move.y, move.toX, move.toY);
            var ennemyMoves = virtualBoard.getLegalMovesFlat();
            var mustKill = ennemyMoves.length &&
                !!virtualBoard.getPiece(ennemyMoves[0].toX, ennemyMoves[0].toY);
            var score = 100;
            if (mustKill) {
                score += 100;
            }
            if (numEnnemies > 6) {
                score -= ennemyMoves.length;
            }
            if (numPieces <= 6 && piece.type === pieces_1.King.key) {
                score -= 50;
            }
            if (piece.type === pieces_1.Pawn.key) {
                score += piece.color === constantes_1.White ? piece.y : constantes_1.HEIGHT - piece.y - 1;
            }
            var newState = virtualBoard.getState();
            var willNeedToKill = false;
            var minNumPossibleMoves = Infinity;
            ennemyMoves.forEach(function (move) {
                virtualBoard.setState(newState);
                virtualBoard.move(move.x, move.y, move.toX, move.toY);
                if (virtualBoard.mustBePromoted) {
                    virtualBoard.promote();
                }
                var possibleMoves = virtualBoard.getLegalMovesFlat();
                if (possibleMoves.length < minNumPossibleMoves) {
                    minNumPossibleMoves = possibleMoves.length;
                }
                willNeedToKill = possibleMoves.some(function (myMove) {
                    if (virtualBoard.getPiece(myMove.toX, myMove.toY)) {
                        return true;
                    }
                });
            });
            score += minNumPossibleMoves;
            if (willNeedToKill) {
                score -= 50;
            }
            if (score >= bestScore) {
                bestMove = move;
                bestScore = score;
            }
        });
        if (bestMove) {
            this.delayAction(function () {
                return _this.board.move(bestMove.x, bestMove.y, bestMove.toX, bestMove.toY);
            });
        }
        console.log('AI found best move:', bestMove, bestScore);
    };
    AI.prototype.promote = function (state) {
        console.log('AI find best promote');
        var toPromote = this.board.mustBePromoted;
        var bestType;
        var bestScore = -Infinity;
        Object.keys(pieces_1.types).forEach(function (key) {
            var type = pieces_1.types[key];
            if (type.canPromote) {
                var score = 100;
                virtualBoard.setState(state);
                virtualBoard.promote(type);
                var newState_1 = virtualBoard.getState();
                var ennemyMoves = virtualBoard.getLegalMovesFlat();
                var willNeedToKill_1 = false;
                var minNumPossibleMoves_1 = Infinity;
                ennemyMoves.forEach(function (move) {
                    virtualBoard.setState(newState_1);
                    virtualBoard.move(move.x, move.y, move.toX, move.toY);
                    if (virtualBoard.mustBePromoted) {
                        virtualBoard.promote();
                    }
                    var possibleMoves = virtualBoard.getLegalMovesFlat();
                    if (possibleMoves.length < minNumPossibleMoves_1) {
                        minNumPossibleMoves_1 = possibleMoves.length;
                    }
                    possibleMoves.forEach(function (myMove) {
                        if (myMove.x === toPromote.x &&
                            myMove.y === toPromote.y &&
                            virtualBoard.getPiece(myMove.toX, myMove.toY)) {
                            willNeedToKill_1 = true;
                        }
                    });
                });
                score += minNumPossibleMoves_1;
                if (willNeedToKill_1) {
                    score -= 50;
                }
                if (score > bestScore) {
                    bestScore = score;
                    bestType = type;
                }
            }
        });
        console.log('AI found best promote:', bestType.key, bestScore);
        this.board.promote(bestType);
    };
    AI.prototype.delayAction = function (fn) {
        clearTimeout(this.actionTimeout);
        this.actionTimeout = setTimeout(fn, this.delay);
    };
    AI.prototype.destroy = function () {
        clearTimeout(this.actionTimeout);
        this.board.history.unsubscribe(this.onHistoryChange);
        this.board = null;
    };
    return AI;
}());
exports.default = AI;



/*****************
 ** WEBPACK FOOTER
 ** ../brchess-core/dist/AI.js
 ** module id = 6
 ** module chunks = 0
 **/